import { useCallback, useMemo } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  saveFilterPreference,
  selectAllFilterPreferences,
} from '@user/store/userPreferences'
import { useSelector } from 'react-redux'
import { setOrderBy } from '@user/store/scWebHooks'

export const useSaveFilters = () => {
  const dispatch = useAppDispatch()

  const prefs = useSelector(selectAllFilterPreferences)

  const usersPref = useMemo(
    () => prefs.find((p) => p.type === 'scWebhooks'),
    [prefs],
  )

  return useCallback(
    (orderBy: string) => {
      dispatch(
        saveFilterPreference({
          id: usersPref?.id,
          type: 'scWebhooks',
          name: 'scWebhooks filters',
          filter: JSON.stringify({ orderBy }),
        }),
      )
      dispatch(setOrderBy(orderBy))
    },
    [dispatch, usersPref?.id],
  )
}
